// Create Action Constants
export enum LoadingIndicatorActionTypes {
  SHOW_LOADING = 'SHOW_LOADING',
  HIDE_LOADING = 'HIDE_LOADING'
}


// Interface for Get All Action Type
export interface IShowLoadingAction {
  type: LoadingIndicatorActionTypes.SHOW_LOADING;
}

export interface IHideLoadingAction {
  type: LoadingIndicatorActionTypes.HIDE_LOADING;
}

export type LoadingIndicatorActions = IShowLoadingAction | IHideLoadingAction;
